import WorkflowsTable from './Table';

export default WorkflowsTable;
